import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'shared/shared.module';
import { ContextualActionComponent } from './contextual-action.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    ContextualActionComponent,
  ],
  exports: [
    ContextualActionComponent,
  ],
  providers: []
})
export class ContextualActionModule {}
